import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Account.UpdateUser.IRequest;
type Response = Api.Core.Account.UpdateUser.IResponse;
type Headers = Api.Core.Account.UpdateUser.IHeaders;
const apiAccountUpdateUserPath = '/api/Account/UpdateUser';
export default async function accountUpdateUserApi(request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: apiAccountUpdateUserPath,
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
